import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    SubTitle,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import { departureBarChartData, departureBarChartOptions } from "../utils/format-departure-bar-data";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    SubTitle,
    Tooltip,
    Legend
);

const DepartureBarChart = ({ chartData }) => {
    // console.log(chartData);
    return (
        <div className="chart-container">
            {<Bar
                data={departureBarChartData(chartData)}
                options={departureBarChartOptions(chartData)}
            />}
        </div>
    );
};

export default DepartureBarChart;
